import { render, staticRenderFns } from "./headerDefault.vue?vue&type=template&id=3d859230&scoped=true"
import script from "./headerDefault.vue?vue&type=script&lang=js"
export * from "./headerDefault.vue?vue&type=script&lang=js"
import style0 from "./headerDefault.vue?vue&type=style&index=0&id=3d859230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d859230",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputRegion: require('/var/www/html/jayuvillage/components/inputRegion.vue').default,Modal: require('/var/www/html/jayuvillage/components/modal.vue').default,Finder: require('/var/www/html/jayuvillage/components/finder.vue').default})
